import "./CaregiverCorner.module.css";
import Header from "@/reusable_sections/Header";
import ServicesOverview from "./sections/ServicesOverview";
import LatestArticles from "./sections/LatestArticles";
import GetSupport from "./sections/GetSupport";
import Footer from "@/reusable_sections/Footer";
export default function CaregiverCornerPage() {
  return <div>
      <Header />
      <ServicesOverview />
      <LatestArticles />
      <GetSupport />
      <Footer />
    </div>;
}